const isAnchorPath = (p: string) => p.startsWith('#');

export default isAnchorPath;
